import { render, staticRenderFns } from "./rateDay.vue?vue&type=template&id=4fc6cd56"
import script from "./rateDay.vue?vue&type=script&lang=js"
export * from "./rateDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports